import { Box } from "@mui/material";
import { DotLegalButton } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import { useUserContext } from "../../auth/userContextProvider/UserContextProvider";
import octopus from "./AIOctopus.svg";
import { useUrlProvider } from "../../useUrlProvider";
import { usePlanContext } from "../../auth/planProvider/PlanProvider";

function AiAdministrationTopBar() {
    const { translateString } = useTranslation();
    const { language } = useUserContext();
    const { getPurchasePlansUrl } = useUrlProvider();
    const { addonsFeatures } = usePlanContext();

    function onLearnMoreClick() {
        if (language === "da") {
            window.open("https://www.dotlegal.com/da/produkt/ai-features", "_blank");
        } else {
            window.open("https://www.dotlegal.com/en/product/ai-features/", "_blank");
        }
    }

    function onActivateClick() {
        window.location.href = getPurchasePlansUrl();
    }

    return (
        <Box
            sx={{
                borderRadius: 2,
                padding: 4,
                background: "linear-gradient(135deg, #F7D2EC 0%, #FCF8A880 100%)",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 2,
                minHeight: 160,
            }}
        >
            <Box sx={{ display: "flex", gap: 2 }}>
                {!addonsFeatures.aiFeatures && (
                    <DotLegalButton btnLength={200} buttonType="primary" toolTip={translateString("activateAiFeaturesTooltip")} onClick={onActivateClick}>
                        {translateString("activateAiFeatures")}
                    </DotLegalButton>
                )}

                <DotLegalButton btnLength={200} buttonType="secondary" onClick={onLearnMoreClick}>
                    {translateString("learnAboutDotLegalAi")}
                </DotLegalButton>
            </Box>
            <Box
                component="img"
                src={octopus}
                alt=""
                sx={{
                    height: 100,
                    marginRight: 10,
                    pointerEvents: "none",
                }}
            />
        </Box>
    );
}

export default AiAdministrationTopBar;
